export default function WhyUs() {

  const items = [
    { title: '01. Extensive analytics',
      description: "ProfitPalms Analytics collects and analyzes data on your listing: organic and advertising sales, number of sessions, organic and advertising conversion rates, CTR, costs, profits, and many more, in the form of convenient charts and tables."
    },
    { title: '02. Long-term data storage',
      description: "Unlike the Amazon Seller Center, ProfitPalms Analytics displays data for a long period, which allows you to track seasonality or other factors that affect sales."
    },
    { title: '03. Track the impact of changes',
      description: "The 'A/B testing' feature allows us to understand how sales are affected by changes in the price of a product, the launch of new advertising campaigns, or listing improvements."
    },
    { title: '04. Track your competitors activities and sales',
      description: "So you will know what alters your competitors are making to their listings and what results they are achieving."
    },
    { title: '05. Timely replenishment of the warehouse',
      description: "This feature keeps track of how many goods are available in the Amazon warehouse. Ability to set up triggers will signal when you need to replenish goods and secure you from getting Out of Stock."
    },
    { title: '06. Amazon search result analysis',
      description: "This feature tracks and shows for which keywords and on which pages and positions of Amazon search result displays your product."
    },

  ];

  return (
    <section id="whyus" className="block block-dark block-whyus">
      <div className="container">
        <h2 className="fw-bold text-center">Why us?</h2>
        <div className="block-description text-start">
          We have developed an analytical service for our clients - ProfitPalms Analytics, which gives you access to the most valuable data and the opportunity to get significant advantages in the Amazon marketplace. Thanks to ProfitPalms Analytics, the following features will become available to you:
        </div>
        <div className="row g-4">
          {items.map((item, index) => (
            <div className="col-12 col-sm-6 col-lg-4" key={index}>
              <div className="item p-4">
                  <h4 className="title fw-bold d-flex align-items-center">{item.title}</h4>
                  <div className="description text-start">
                    {item.description}
                  </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
